module.exports = __webpack_public_path__ + "static/zs-vlasim-dfb18beb9d0ef6f81af1460d1d8efe18.png";